import React from "react";
import AppForm from "./AppForm";
import { createApplication } from "../api/APIUtils";
import _ from "lodash";
const AddApp = ({ history, isAdmin, isOperator }) => {
  const handleOnSubmit = (app) => {
    createApplication(app)
      .then((response) => {
        console.log(response);
      })
      .catch((e) => {
        const err = _.get(e, "errors")
        const error = _.find(err, "message")
        console.log(error);
        alert(error.message);
      })
      .finally(() => {
        history.push("/");
      });
  };
  return (
    <React.Fragment>
      <AppForm handleOnSubmit={handleOnSubmit} isAdmin={isAdmin} isOperator={isOperator} />
    </React.Fragment>
  );
};

export default AddApp;
